// @flow

import React from 'react';
import AtomicInput from './AtomicInput';
import type { AtomicInputProps } from './AtomicInput';

type CheckboxInputProps<CheckedType, UncheckedType> = {
  checkedValue?: CheckedType,
  uncheckedValue?: UncheckedType,
} & AtomicInputProps<CheckedType | UncheckedType>;

export default class CheckboxInput<
  CheckedType = true,
  UncheckedType = false,
  AdditionalProps = {},
> extends AtomicInput<
  CheckedType | UncheckedType,
  boolean,
  CheckboxInputProps<CheckedType, UncheckedType> & AdditionalProps,
> {
  static defaultProps = {
    ...AtomicInput.defaultProps,
    required: false,
    checkedValue: true,
    uncheckedValue: false,
  };

  valueToDomValue(value: CheckedType | UncheckedType): boolean {
    if (value === this.props.checkedValue) {
      return true;
    }
    if (value === this.props.uncheckedValue) {
      return false;
    }
    throw new Error(
      `Invalid value for ${this.constructor.displayName || this.constructor.name}: ` +
        `${String(value)} - matches neither checkedValue (${String(
          this.props.checkedValue,
        )}), nor uncheckedValue ` +
        `(${String(this.props.uncheckedValue)})!`,
    );
  }

  domValueToValue(rawValue: boolean): CheckedType | UncheckedType {
    if (rawValue) {
      return this.props.checkedValue;
    }
    return this.props.uncheckedValue;
  }

  hasValue() {
    return this.domValue;
  }

  render() {
    return (
      <input
        className={this.props.className}
        type="checkbox"
        checked={this.domValue}
        onChange={ev => {
          this.inputDidChange(ev.target.checked);
          this.inputDidCommitChange();
        }}
        name={this.parent ? this.name : ''}
      />
    );
  }
}
